<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout justify-start column>
    <div style="width: calc(100%)">
      <div>
        <SimpleCard>
          <v-layout row wrap align-content-center justify-center>
            <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
              <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
            </v-flex>
            <AccountBookingSummaryList
              @bookingTypesUpdated="updateBookingTypes"
              @locationTypesUpdated="updateLocationTypes"
              @updateTodayBookings="updateTodayBookings"
              v-if="!loading"
              @search="search"
              :query="query"
              style="width: 100%;"
              :bookings="bookings"
              :paginationProp="pagination"
              :rideTypes="rideTypes"
              @reload="getBookings"
              @updatePaymentType="updatePaymentType($event)"
              @setFinalCost="setFinalCost($event)"
              @setDriverPay="setDriverPay($event)"
              @setCommission="setCommission($event)"
              @resetCommission="resetCommission($event)"
              @addExtra="addExtra($event)"
              @removeExtra="removeExtra($event)"
              @sendInvoice="sendInvoice($event)"
              @errorSnackbar="showSnackbar($event, 'error')"
              @commissionChanged="commissionChanged"
            ></AccountBookingSummaryList>
            <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
              <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </div>
    </div>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import AccountBookingSummaryList from "@/components/booking/AccountBookingSummaryList.vue";
import BookingSearchBox from "@/components/booking/BookingSearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "AccountBookings",
  components: {
    SimpleCard,
    AccountBookingSummaryList,
    BookingSearchBox,
  },

  data: function () {
    return {
      bookings: [],
      offset: 0,
      count: 25,
      query: {
        todayBookings: "",
        state: "completed",
        name: "",
        number: "",
        pickup: "",
        destination: "",
        before: "",
        after: "",
        paymentType: "all",
        bookingMethod: "all",
        locationTypes: "",
        refNum: "",
        bookingID: null,
        hideRepeatTrips: false,
        preassignedDriver: ""
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      rideTypes: [],
      locationTypes: [
        {
          id: 1,
          value: 'airport',
          name: 'Airport',
        },
        {
          id: 2,
          value: 'cruise',
          name: 'Cruise',
        },
        {
          id: 3,
          value: "bus_station",
          name: "Bus Station"
        },
        {
          id: 4,
          value: "doctor",
          name: "Doctor"
        },
        {
          id: 5,
          value: "hospital",
          name: "Hospital"
        },
        {
          id: 6,
          value: "light_rail_station",
          name: "Light Rail Station"
        },
        {
          id: 7,
          value: "local_government_office",
          name: "Local Government Office"
        },
        {
          id: 8,
          value: "primary_school",
          name: "Primary School"
        },
        {
          id: 8,
          value: "school",
          name: "School"
        },
        {
          id: 8,
          value: "secondary_school",
          name: "Secondary School"
        },
        {
          id: 8,
          value: "subway_station",
          name: "Subway Station"
        },
        {
          id: 8,
          value: "tourist_attraction",
          name: "Tourist Attraction"
        },
        {
          id: 8,
          value: "train_station",
          name: "Train Station"
        },
        {
          id: 8,
          value: "transit_station",
          name: "Transit Station"
        },
        {
          id: 8,
          value: "university",
          name: "University"
        },
        {
          id: 8,
          value: "Zoo",
          name: "Zoo"
        },
        {
          id: 8,
          value: "primary_school",
          name: "Primary School"
        },
        {
          id: 8,
          value: "primary_school",
          name: "Primary School"
        },
      ],
      bookingTypes: [
        {
          id: 1,
          value: "phone",
          name: "Phone"
        },
        {
          id: 2,
          value: "app",
          name: "App"
        },
        {
          id: 3,
          value: "website",
          name: "Website"
        },
        {
          id: 4,
          value: "third_party",
          name: "Third Party"
        },
        {
          id: 4,
          value: "flag_down",
          name: "Flag Down"
        },
        {
          id: 4,
          value: "repeat",
          name: "Repeat"
        },
      ],
    };
  },
  computed: {
    bookingsTypeValues () {
      let onlyValues = [];
        this.bookingTypes.forEach(bookingType => {
          onlyValues.push(bookingType.value)
      })
      return onlyValues
    },
    locationTypeValues () {
      let onlyValues = [];
        this.locationTypes.forEach(bookingType => {
          onlyValues.push(bookingType.value)
      })
      return onlyValues
    }
  },
  mounted: async function () {
    if (this.$route.query.bookingID) {
      this.query.bookingID = this.$route.query.bookingID;
      this.query.before = "";
      this.query.state = "all";
    }

    if (this.$route.query.contact_number) {
      this.query.number = this.$route.query.contact_number;
      this.query.before = "";
      this.query.state = "all";
    }

    if (this.$route.query.name) {
      this.query.name = this.$route.query.name;
      this.query.before = "";
      this.query.state = "all";
    }
    this.getBookings();
    this.getRideTypes();
  },
  methods: {
    updatePaymentType: function (data) {
      console.log("updating payment type");
      this.invoiceRowRefreshID = data.invoice.id;
      let self = this;
      let bookingID = data.bookingID;
      let url = `${this.$store.state.apiUrl}/invoice/driver/changePaymentType?booking_id=${bookingID}&payment_type=${data.paymentType}`;
    
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set set payment type", "error");
          } else {
            self.showSnackbar("Successfully set payment type", "success");
            self.getBookings()
          
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set payment type", "error");
        });
    },
    setFinalCost: function (data) {
      console.log("setting final cost");
      this.invoiceRowRefreshID = data.invoice.id;
      let self = this;
      let bookingID = data.bookingID;
      let amount = Math.round(data.amount * 100);
      let url = `${this.$store.state.apiUrl}/invoice/driver/setBookingFinalCost?booking_id=${bookingID}&amount=${amount}`;
    
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set final cost", "error");
          } else {
            self.showSnackbar("Successfully set final cost", "success");
            self.getBookings()
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set final cost", "error");
        });
    },
    setDriverPay: function (data) {
      console.log("setting driver pay");
      this.invoiceRowRefreshID = data.invoice.id;
      let self = this;
      let bookingID = data.bookingID;
      let amount = Math.round(data.amount * 100);
      let url = `${this.$store.state.apiUrl}/invoice/driver/manuallySetDriverPay?booking_id=${bookingID}&amount=${amount}`;
    
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set driver pay", "error");
          } else {
            self.showSnackbar("Successfully set driver pay", "success");
            self.getBookings()
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set driver pay", "error");
        });
    },
    setCommission: function (data) {
      console.log("setting commssion");
      this.invoiceRowRefreshID = data.invoice.id;
      let self = this;
      let bookingID = data.bookingID;
      let amount = Math.round(data.amount * 100);
      let url = `${this.$store.state.apiUrl}/invoice/driver/manuallySetCharge?booking_id=${bookingID}&amount=${amount}`;
    
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set commission", "error");
          } else {
            self.showSnackbar("Successfully set commission", "success");
            self.getBookings()
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set commission", "error");
        });
    },
    resetCommission: function (bookingID) {
      console.log("resetting commssion");
      // this.invoiceRowRefreshID = this.invoiceDetails.invoice.id;
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/resetCharge?booking_id=${bookingID}`;
    
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to reset commission", "error");
          } else {
            self.showSnackbar("Successfully reset commission", "success");
            self.getBookings()
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to reset commission", "error");
        });
    },
    addExtra: function (extra) {
      console.log("adding extra");
      this.invoiceRowRefreshID = extra.invoice.id;
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/addExtra`;
      extra.amount = Math.round(extra.amount * 100);
      axios({
        url: url,
        method: "POST",
        params: extra,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar(
              "Failed to add extra: " + res.data.message,
              "error"
            );
          } else {
            self.showSnackbar("Successfully added extra", "success");
            self.getBookings()
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to add extra", "error");
        });
    },
    removeExtra: function (extraID) {
      console.log("removing extra");
      // this.invoiceRowRefreshID = this.invoiceDetails.invoice.id;
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/removeExtra/?extra_id=${extraID}`;
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar(
              "Failed to remove extra: " + res.data.message,
              "error"
            );
          } else {
            self.showSnackbar("Successfully removed extra", "success");
            self.getBookings()
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to remove extra", "error");
        });
    },
    sendInvoice: function (invoiceID) {
      console.log("sending invoice");
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/sendInvoice/?invoice_id=${invoiceID}`;
    
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar(
              "Failed to send invoice: " + res.data.message,
              "error"
            );
          } else {
            self.showSnackbar("Successfully sent invoice", "success");
            self.getCurrentInvoices();
            self.invoiceDetails = null;
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to send invoice", "error");
        });
    },
    updateInvoiceRowSummary: function (invoice) {
      console.log("updating invoice row");
      let invoiceRow = {
        date: invoice.date,
        created_time: invoice.created_time,
        id: invoice.id,
        paid: invoice.paid,
        sent: invoice.sent,
        totals: invoice.totals,
      };
      if (invoice.paid_time) {
        invoiceRow.paid_time = invoice.paid_time;
      }
    
      if (this.invoices) {
        for (let i = 0; i < this.invoices.length; i++) {
          if (this.invoices[i].id == invoice.id) {
            this.$set(this.invoices, i, invoiceRow);
          }
        }
      }
    
      this.invoiceRowRefreshID = -1;
    },
    commissionChanged: function (a, b, invoice) {
      this.updateInvoiceRowSummary(invoice);
      this.$set(this.invoiceDetails, "invoice", invoice);
    
      if (this.viewing == "unpaid") {
        this.getUnpaidDriverTotals();
      } else if (this.viewing == "all") {
        this.getAllInvoices(this.currentOffset);
      }
    },
  
    showSnackbar: function (message, colour) {
      return;
      this.snackbarMessage = message;
      this.snackbarColour = colour;
      this.snackbarShow = true;
    },
    updateTodayBookings () {
      if (this.query.todayBookings) {
        this.count = -1;
        this.query.before = moment().format("YYYY-MM-DD")
        this.query.after = moment().format("YYYY-MM-DD")
      } else {
        this.count = 25
        this.query.before = ""
        this.query.after = ""
      }
      this.getBookings()
    },
    search: function () {
      this.pagination.page = 1;
      this.getBookings();
    },
    updateBookingTypes (payload) {
      if (payload.includes('all')) {
        this.query.bookingMethod = "all"
      } else {
        this.query.bookingMethod = payload.join()
      }
    },
    updateLocationTypes (payload) {
      if (payload.includes('all')) {
        this.query.locationTypes = ""
      } else {
        this.query.locationTypes = payload.join()
      }
    },
    clear: function () {
      this.query.state = "all";
      this.query.name = "";
      this.query.number = "";
      this.query.pickup = "";
      this.query.destination = "";
      this.query.before = "";
      this.query.after = "";
      this.query.paymentType = "all";
      this.query.bookingMethod = "all";
      this.query.refNum = "";
      this.query.bookingID = null;

      this.getBookings();
    },
    changePage: function (page) {
      this.pagination.page = page;
      console.log(page);
      this.getBookings();
    },
    getBookings: async function () {
      this.loading = true;

      try {
        var url;

        // if (this.query.bookingID == null || this.query.bookingID == "") {
        url = `${this.$store.state.apiUrl}/account_booking/list?offset=${
          this.count * (this.pagination.page - 1)
        }&count=${this.count}&state=${this.query.state}&name=${
          this.query.name
        }&number=${this.query.number.trim()}&paymentType=${
          this.query.paymentType
        }&before=${
          this.query.before
        }&after=${this.query.after}&hideRepeatTrips=${
          this.query.hideRepeatTrips
        }`;

        if (this.query.locationTypes != null && this.query.locationTypes != "") {
          url += `&locationTypes=${this.query.locationTypes}`
        }

        if (this.query.refNum != null && this.query.refNum != "") {
          url += `&refNum=${this.query.refNum}`;
        }

        // if (this.query.bookingID != null && this.query.bookingID != "") {
        //   url += `&bookingID=${this.query.bookingID}`;
        // }

        if (this.query.pickup != null && this.query.pickup != "") {
          url += `&pickup=${this.query.pickup}`;
        }

        if (this.query.destination != null && this.query.destination != "") {
          url += `&destination=${this.query.destination}`;
        }
        if (this.query.bookingMethod != null && this.query.bookingMethod !== "") {
          url += `&bookingMethod=${this.query.bookingMethod}`;
        }

        if (this.query.bookingID != null && this.query.bookingID != "") {
          url += `&bookingID=${this.query.bookingID}`;
        }

        if (this.query.preassignedDriver != null && this.query.preassignedDriver != "") {
          url += `&preassignedDriver=${this.query.preassignedDriver}`
        }


        let response = await axios.get(url, {
          params: {},
        });

        var bookings = response.data.bookings;

        for (var i = 0; i < bookings.length; i++) {
          if (bookings[i].preassigned_driver_id == null) {
             bookings[i].preassigned_driver_id = "";
             bookings[i].preassigned_driver_name = "";
             bookings[i].preassigned_driver_callsign = "";
          }
        }

        this.bookings = bookings;

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        console.log(response.data.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get bookings " + error);
      }
    },
    getRideTypes: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.rideTypes = response.data;

        this.getRepeatService();

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>


<style lang="scss">

  .v-select .v-input__icon--append {
    display: none;
  }
</style>